export enum AccountHolderType {
  Business = 'BUSINESS',
  Personal = 'PERSONAL',
}
